import { render, staticRenderFns } from "./PetHealthPreview.vue?vue&type=template&id=31d1ac42&scoped=true&"
import script from "./PetHealthPreview.vue?vue&type=script&lang=js&"
export * from "./PetHealthPreview.vue?vue&type=script&lang=js&"
import style0 from "./PetHealthPreview.vue?vue&type=style&index=0&id=31d1ac42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1ac42",
  null
  
)

export default component.exports